export const ADD_ITEM_IN_CART = "ADD_ITEM_IN_CART";
export const SHOW_CART_DLG = "SHOW_CART_DLG";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const UPDATE_CART_ITEM_QUANTITY = "UPDATE_CART_ITEM_QUANTITY";
export const SET_CHECKEDOUT_ITEMS = "SET_CHECKEDOUT_ITEMS";
export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const LOGOUT = "LOGOUT";
export const ADD_ITEMS_FROM_LOCALSTORE = "ADD_ITEMS_FROM_LOCALSTORE"
